import { render, staticRenderFns } from "./goal-home.page.vue?vue&type=template&id=26a6a72a&scoped=true"
import script from "./goal-home.page.vue?vue&type=script&lang=ts"
export * from "./goal-home.page.vue?vue&type=script&lang=ts"
import style0 from "./goal-home.page.vue?vue&type=style&index=0&id=26a6a72a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a6a72a",
  null
  
)

export default component.exports